module.exports = "/virtual-football-league/img/amblems/right/logos/Fake_Chelsea.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Fake_Chelsea.png
// module id = 2184
// module chunks = 4